import { ShieldCheck, ExternalLink } from "lucide-react";

const ENCYRO_URL = "https://www.encyro.com/helliotassociates@gmail.com";

/**
 * Encrypted-upload call-to-action via Encyro.
 * variant: "primary" (dark filled), "accent" (gold filled), "card" (full panel with explainer)
 */
export default function EncyroLink({ variant = "primary", label = "Upload Documents Securely", className = "" }) {
  if (variant === "card") {
    return (
      <div
        data-testid="encyro-card"
        className={`bg-white border border-black/10 p-8 md:p-10 ${className}`}
      >
        <div className="flex items-start gap-4 mb-4">
          <div className="w-12 h-12 bg-[#8E6A2B] flex items-center justify-center flex-shrink-0">
            <ShieldCheck size={22} className="text-[#0F292F]" />
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#8E6A2B] mb-2">
              Encrypted File Transfer · Encyro
            </div>
            <h3 className="font-serif text-2xl text-[#0F292F] leading-tight">
              Send documents securely — no account required.
            </h3>
          </div>
        </div>
        <p className="text-[#52525B] leading-relaxed mb-6 max-w-xl">
          Use Encyro to send tax forms, statements, IRS notices, or any sensitive document
          with end-to-end encryption. Files are transmitted directly to Harold's secure
          inbox. No signup, no portal login — just upload and send.
        </p>
        <a
          href={ENCYRO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="encyro-card-cta"
          className="btn-accent"
        >
          <ShieldCheck size={16} /> {label} <ExternalLink size={14} />
        </a>
      </div>
    );
  }

  const cls = variant === "accent" ? "btn-accent" : "btn-primary";
  return (
    <a
      href={ENCYRO_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="encyro-link"
      className={`${cls} ${className}`}
    >
      <ShieldCheck size={16} /> {label} <ExternalLink size={14} />
    </a>
  );
}
